// extracted by mini-css-extract-plugin
export default {"metaData":"metaData--HXpon","left":"left--lbwEu","right":"right--SBJ4J","xSplit":"xSplit--sSMUQ"};